import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableExporterModule } from 'mat-table-exporter';

import { ConfirmacaoDialogComponent } from './confirmacao-dialog/confirmacao-dialog.component';
import { ExportacaoDialogComponent } from './exportacao-dialog/exportacao-dialog.component';
import { FilterBoxComponent } from './filter-box/filter-box.component';
import { FlashMessageComponent } from './flash-message/flash-message.component';
import { FormBoxComponent } from './form-box/form-box.component';
import { ListBoxComponent } from './list-box/list-box.component';
import { OrchestratorBoxComponent } from './orchestrator-box/orchestrator-box.component';
import { TitleBoxComponent } from './title-box/title-box.component';
import { VisualizadorImagemDialogComponent } from './visualizador-imagem-dialog/visualizador-imagem-dialog.component';

const COMPONENTS = [
  ConfirmacaoDialogComponent,
  ExportacaoDialogComponent,
  FilterBoxComponent,
  FlashMessageComponent,
  FormBoxComponent,
  ListBoxComponent,
  OrchestratorBoxComponent,
  TitleBoxComponent,
  VisualizadorImagemDialogComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatRadioModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTableExporterModule,
    MatTooltipModule,
  ],
  exports: COMPONENTS,
})
export class SharedComponentsModule {}
